import useMoney from '../../../../../../../hooks/useMoney';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { OrderError } from '../../../../sections/OrderEditSections.types';
import { getBusinessPolicyViolationViews } from '../businessPolicyViolation.utils';

export const useBusinessPolicyViolationViews = (errors: OrderError[]) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  return getBusinessPolicyViolationViews({ errors, translate, formatMoney });
};
